import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/settings/admin/grapheme-file-editor",
      },
      queries: [],
    }),
    [],
  );
}

export const useGraphemeFileEditorSettingsPageNavigator = createPageNavigator<void>({
  useNavigator,
});
